export default function MyDeals() {
    return (
      <div>
        <h1 className="text-2xl font-bold mb-4">My Deals</h1>
        <p>Startups you're evaluating...</p>
      </div>
    );
  }
  